import { render, staticRenderFns } from "./LayoutBulkUpdater.vue?vue&type=template&id=b87b98d6&scoped=true"
import script from "./LayoutBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./LayoutBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./LayoutBulkUpdater.vue?vue&type=style&index=0&id=b87b98d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b98d6",
  null
  
)

export default component.exports